import React from "react";
import {
  GridLayout,
  ParticipantTile,
  useTracks,
  useLocalParticipant,
} from "@livekit/components-react";
import { Track } from "livekit-client";
import { CustomControlBar } from "./custom-control-bar";

// Define the props for the CustomVideoConference component (if needed)
interface CustomVideoConferenceProps {
  // roomToken: string; // Token for the LiveKit room
  // serverUrl: string; // URL of the LiveKit server
  identity: string | null;
}

export const CustomVideoConference: React.FC<CustomVideoConferenceProps> = (
  props,
) => {
  // Get the local participant
  const { localParticipant } = useLocalParticipant();
  localParticipant.identity = props.identity ?? "Default Identity";
  // Filter tracks to include only the camera source (for local participant)
  const localTracks = useTracks(
    [{ source: Track.Source.Camera, withPlaceholder: true }],
    {
      onlySubscribed: true,
    },
  ).filter((track) => track.participant === localParticipant);

  return (
    <div className="custom-video-conference w-full h-full flex flex-col items-center justify-center">
      {/* Video Section */}
      <div className="video-section w-full h-full flex items-center justify-center">
        <GridLayout tracks={localTracks}>
          {localParticipant && <ParticipantTile trackRef={localTracks[0]} />}
        </GridLayout>
      </div>

      {/* Control Bar Section */}
      <CustomControlBar />
    </div>
  );
};
